import { DOMNodeExtended } from './types';

export function getNodeTextContent(node: DOMNodeExtended): string {
  let string = '';
  let recursiveNode: DOMNodeExtended | undefined = node;
  let depthCounter = 0;
  const maxDepth = 10;
  while (recursiveNode && depthCounter < maxDepth) {
    depthCounter += 1;
    recursiveNode = node?.children?.length ? node?.children[0] : undefined;
    if (recursiveNode?.type === 'text') {
      string = recursiveNode?.data || '';
      break;
    }
  }
  return string;
}
